export default {
      id: "ic_mp_my_coupon-usage",
      viewBox: "0 0 40 40",
      url: "/" + "images/icons.3.109.2.svg#ic_mp_my_coupon-usage",
      toString: function () {
        return this.url;
      }
    }